import {API_LOGIN} from 'consts/api'
import {ServiceMap} from 'types/commons'
import {getAPIBaseUrl} from 'utils/commons'
import {ServiceParamAuth} from './ServiceParamAuth'

export const SERVICE_MAP_AUTH: ServiceMap<ServiceParamAuth> = {
  auth_login: {
    url: getAPIBaseUrl() + API_LOGIN,
    method: 'POST',
  },
}
